<div class="m-3 h-100">
  <div class="w-100 d-flex justify-content-end">
    <mat-icon mat-dialog-close style="color: #fbf9f4;">
      close
    </mat-icon>
  </div>
  <mat-stepper #stepper class="carousel-stepper" [linear]="false">
    @for (image of data.carouselImages; track image.id; let first = $first, last = $last) {
      <mat-step>
        <div class="w-100 d-flex align-items-center justify-content-center mb-3">
          <button tabIndex="0" [disabled]="first" matButton="outlined" matStepperPrevious>
            <mat-icon class="p-0 m-0">arrow_back_ios</mat-icon>
          </button>
          <button tabIndex="1" [disabled]="last" matButton="outlined" matStepperNext>
            <mat-icon class="p-0 m-0">arrow_forward_ios</mat-icon>
          </button>
        </div>
        <div class="d-flex align-items-center justify-content-center">
          <img class="carousel-image" [src]="image.imageUrl" [alt]="image.name">
        </div>
      </mat-step>
    }
  </mat-stepper>
  <!-- Pagination Dots -->
  <div class="dots">
    @for (image of data.carouselImages; track image.id; let i = $index) {
      <div
        [tabindex]="i+2"
        class="dot"
        role="button"
        [class.active]="stepper.selectedIndex === i"
        (click)="stepper.selectedIndex = i"
        (keydown.space)="stepper.selectedIndex = i"
      ></div>
    }
  </div>
</div>
